import { Image, Pressable } from 'react-native'

import { useModal } from '@zet/common/hooks/useModal'
import { B4, Icon, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { DEVICE_WIDTH } from '@zet/utils/Constants'

type CustomImageHeaderProps = {
  bannerUrl: string
}
const CustomImageHeader = ({ bannerUrl }: CustomImageHeaderProps) => {
  const { openModal } = useModal()

  const handlePress = () => {
    openModal('WebFlowSelectorModal', {
      title: i18n.t('appLanguage.choose'),
      iconName: 'BankOutlined',
      criteriaName: 'languageModal',
      options: ['English', 'Hindi'],
    })
  }
  return (
    <Stack>
      <Image
        style={{
          width: DEVICE_WIDTH >= 640 ? 640 : DEVICE_WIDTH,
          aspectRatio: 1.72,
        }}
        source={{
          uri: bannerUrl,
        }}
        resizeMode="cover"
      />
      <Pressable
        onPress={handlePress}
        className="bg-primary-100 px-4/2 absolute right-3 top-3 rounded py-1"
      >
        <XStack>
          <Icon type="LanguageOutlined" color="#FFF" />
          <B4 className="ml-1 text-white">
            {i18n.t('webFlow.addCustomerHeader.locale')}
          </B4>
        </XStack>
      </Pressable>
    </Stack>
  )
}

export default CustomImageHeader
